import error from './en-US/error';
import menu from './en-US/menu';
import pages from './en-US/pages';
import button from './en-US/button';
import placeholder from './en-US/placeholder';
import validmessage from './en-US/validmessage';
import tipmessage from './en-US/tipmessage';
import home from './en-US/home';

const enUS = {
  'common.loading': 'Loading...',
  'layout.appname': 'DocumentManagement',
  'layout.lang': 'Languages',
  'layout.signout': 'Sign Out',
  ...error,
  ...menu,
  ...pages,
  ...button,
  ...placeholder,
  ...validmessage,
  ...tipmessage,
  ...home,
};
export default enUS;
